import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";

import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import About from "@/components/landing/About";
import Products from "@/components/landing/Products";
import PlywoodTypes from "@/components/landing/PlywoodTypes";
import WhyChooseUs from "@/components/landing/WhyChooseUs";
import Gallery from "@/components/landing/Gallery";
import Testimonials from "@/components/landing/Testimonials";
import EnquiryForm from "@/components/landing/EnquiryForm";
import Footer from "@/components/landing/Footer";
import FloatingActions from "@/components/landing/FloatingActions";

const LandingPage = () => {
  useEffect(() => {
    document.title =
      "New India Trading Corporation · Plywood, Laminate & Flush Door Dealers in Bangalore";
  }, []);

  return (
    <main className="min-h-screen bg-[color:var(--nitc-bg)] text-[color:var(--nitc-ink)]" data-testid="landing-page">
      <Header />
      <Hero />
      <About />
      <Products />
      <PlywoodTypes />
      <WhyChooseUs />
      <Gallery />
      <Testimonials />
      <EnquiryForm />
      <Footer />
      <FloatingActions />
      <Toaster position="bottom-left" richColors closeButton />
    </main>
  );
};

export default LandingPage;
